export default __webpack_public_path__ + "static/media/imperial.4bd86d8b.png";